// src/utils/portfolioTheme.ts

export const getPortfolioThemeStyle = (themeConfig?: string) => {
  switch (themeConfig) {
    case 'THEME:DARK_RED':
      return {
        backgroundColor: 'var(--theme-dark-red-bg)',
        borderColor: 'var(--theme-dark-red-border)',
        boxShadow: '0 8px 24px var(--theme-dark-red-shadow)'
      };
    case 'THEME:BURGUNDY':
      return {
        backgroundColor: 'var(--theme-burgundy-bg)',
        borderColor: 'var(--theme-burgundy-border)',
        boxShadow: '0 8px 24px var(--theme-burgundy-shadow)'
      };
    case 'THEME:INDIGO':
      return {
        backgroundColor: 'var(--theme-indigo-bg)',
        borderColor: 'var(--theme-indigo-border)',
        boxShadow: '0 8px 24px var(--theme-indigo-shadow)'
      };
    case 'THEME:NAVY_BLUE':
      return {
        backgroundColor: 'var(--theme-navy-blue-bg)',
        borderColor: 'var(--theme-navy-blue-border)',
        boxShadow: '0 8px 24px var(--theme-navy-blue-shadow)'
      };
    case 'THEME:FOREST_GREEN':
      return {
        backgroundColor: 'var(--theme-forest-green-bg)',
        borderColor: 'var(--theme-forest-green-border)',
        boxShadow: '0 8px 24px var(--theme-forest-green-shadow)'
      };
    case 'THEME:TEAL':
      return {
        backgroundColor: 'var(--theme-teal-bg)',
        borderColor: 'var(--theme-teal-border)',
        boxShadow: '0 8px 24px var(--theme-teal-shadow)'
      };
    default:
      return {
        backgroundColor: 'var(--component-bg-color)',
        borderColor: 'var(--border-item-light)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
      };
  }
};